<div class="font14">
  <!--<button mat-menu-item>-->
    <!--<span>{{application.user.name}}</span>-->
    <!--<mat-icon style="color: #03a9f4">settings</mat-icon>-->
  <!--</button>-->
  <div class="user-data-wrapper" (click)="menuClosePrevent($event)">
    <div class="user-label-wrapper">{{application.user.shipping_name}}</div>
    <div *ngIf="0 && application.isTrainerLogin()">
      <div class="user-usage-wrapper" style="margin-bottom: 15px;font-weight: bold;">
        <div class="usage-left">
          <span class="usage-label">Services used</span><br>
        </div>
        <div class="usage-right">
          <span class="usage-label">Available</span><br>
        </div>
      </div>
      <div class="user-usage-wrapper">
        <div class="usage-left">
          Users/Clients: <span class="usage-value">10 (10%)</span>
        </div>
        <div class="usage-right">
          <span class="usage-value">100</span>
        </div>
      </div>
      <div class="quota-bar-wrapper">
        <div class="quota-bar-total">
          <div class="quota-bar-value" style="width: 10%"></div>
        </div>
      </div>
      <div class="user-usage-wrapper">
        <div class="usage-left">
          Articles/Lessons: <span class="usage-value">33 (33%)</span>
        </div>
        <div class="usage-right">
          <span class="usage-value">100</span>
        </div>
      </div>
      <div class="quota-bar-wrapper">
        <div class="quota-bar-total">
          <div class="quota-bar-value" style="width: 33%"></div>
        </div>
      </div>
      <div class="user-usage-wrapper">
        <div class="usage-left">
          Workouts: <span class="usage-value">25 (25%)</span>
        </div>
        <div class="usage-right">
          <span class="usage-value">100</span>
        </div>
      </div>
      <div class="quota-bar-wrapper">
        <div class="quota-bar-total">
          <div class="quota-bar-value" style="width: 25%"></div>
        </div>
      </div>
      <div class="user-usage-wrapper">
        <div class="usage-left">
          Recipes: <span class="usage-value">50 (50%)</span>
        </div>
        <div class="usage-right">
          <span class="usage-value">100</span>
        </div>
      </div>
      <div class="quota-bar-wrapper">
        <div class="quota-bar-total">
          <div class="quota-bar-value" style="width: 50%"></div>
        </div>
      </div>
    </div>
  </div>
  <button mat-menu-item (click)="openPasswordChange($event)">
    <mat-icon>volunteer_activism</mat-icon>
    <span>Services settings</span>
  </button>
  <hr>
  <button mat-menu-item (click)="openPasswordChange($event)">
    <mat-icon>shopping_cart</mat-icon>
    <span>Packages settings</span>
  </button>
  <hr>
  <!--<button mat-menu-item (click)="openPasswordChange($event)">-->
    <!--<mat-icon>settings</mat-icon>-->
    <!--<span>Sub admin panel</span>-->
  <!--</button>-->
  <!--<hr>-->
  <button mat-menu-item (click)="openPasswordChange($event)">
    <mat-icon>vpn_key</mat-icon>
    <span>Change password</span>
  </button>
  <!--<hr>-->
  <!--<button mat-menu-item (click)="openAppereance($event)">-->
    <!--<mat-icon>stars</mat-icon>-->
    <!--<span>Appereance</span>-->
    <!--<mat-icon class="right-icon" *ngIf="!toggleAppereance">arrow_drop_down</mat-icon>-->
    <!--<mat-icon class="right-icon" *ngIf="toggleAppereance">arrow_drop_up</mat-icon>-->
  <!--</button>-->
  <!--<div (click)="menuClosePrevent($event)" *ngIf="toggleAppereance">-->
    <!--<hr>-->
    <!--<div class="appereance-toolbar">-->
      <!--<div class="toolbar-checkbox">-->
        <!--<mat-checkbox (change)="toggleToolbar()" [checked]="this.application.bottomToolbar === 'Y'"></mat-checkbox>-->
      <!--</div>-->
      <!--<div class="toolbar-label" (click)="toggleToolbar()">Display bottom toolbar</div>-->
    <!--</div>-->
    <!--<hr>-->
    <!--<div class="appereance-wrapper" (click)="menuClosePrevent($event)">-->
      <!--<div *ngFor="let theme of themesList"-->
           <!--(click)="application.brandingTheme = theme['key']"-->
           <!--[matTooltip]="theme['name']"-->
           <!--[class.theme-preview-selected]="theme['key'] === application.brandingTheme"-->
           <!--[class.theme-preview]="theme['key'] != application.brandingTheme"-->
           <!--style="{{(theme['key'] != application.brandingTheme ? 'background-color: ' + theme['demo-bg'] : '')}}">-->
        <!--<div style="{{(theme['key'] != application.brandingTheme ? 'background-color: ' + theme['demo-accent'] : '')}}"></div>-->
      <!--</div>-->

      <!--&lt;!&ndash;<div class="theme-selected">&ndash;&gt;-->
        <!--&lt;!&ndash;<div style="background-color: #039be5"></div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div style="background-color: #ff9800"></div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div style="background-color: #8bc34a"></div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div style="background-color: yellow"></div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div style="background-color: teal"></div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div style="background-color: #ffd740"></div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div style="background-color: orangered"></div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div style="background-color: #bdbdbd"></div>&ndash;&gt;-->
    <!--</div>-->
  <!--</div>-->
  <hr>
  <button mat-menu-item>
    <mat-icon>help_outline</mat-icon>
    <span>Help</span>
  </button>
  <hr>
  <button mat-menu-item (click)="application.handleLogout()">
    <mat-icon>power_settings_new</mat-icon>
    <span>Sign out</span>
  </button>
  <!--<button mat-menu-item (click)="application.brandingTheme='lightgrey-lightblue-red-theme'">-->
    <!--<mat-icon style="color: #03a9f4">fiber_manual_record</mat-icon>-->
    <!--<span>lightgrey-lightblue-red-theme</span>-->
  <!--</button>-->
  <!--<button mat-menu-item (click)="application.brandingTheme='lightgrey-orange-red-theme'">-->
    <!--<mat-icon style="color: #ff9800">fiber_manual_record</mat-icon>-->
    <!--<span>lightgrey-orange-red-theme</span>-->
  <!--</button>-->
  <!--<button mat-menu-item (click)="application.brandingTheme='lightgrey-lightgreen-red-theme'">-->
    <!--<mat-icon style="color: #8bc34a">fiber_manual_record</mat-icon>-->
    <!--<span>lightgrey-lightgreen-red-theme</span>-->
  <!--</button>-->
  <!--<button mat-menu-item (click)="application.brandingTheme='lightgrey-warm-red-theme'">-->
    <!--<mat-icon style="color: yellow">fiber_manual_record</mat-icon>-->
    <!--<span>lightgrey-warm-red-theme</span>-->
  <!--</button>-->
  <!--<button mat-menu-item (click)="application.brandingTheme='lightgrey-evergreen-red-theme'">-->
    <!--<mat-icon style="color: teal">fiber_manual_record</mat-icon>-->
    <!--<span>lightgrey-evergreen-red-theme</span>-->
  <!--</button>-->
  <!--<button mat-menu-item (click)="application.brandingTheme='dark-amber-red-theme'">-->
    <!--<mat-icon style="color: #ffd740">fiber_manual_record</mat-icon>-->
    <!--<span>dark-amber-red-theme</span>-->
  <!--</button>-->
  <!--<button mat-menu-item (click)="application.brandingTheme='dark-warm-red-theme'">-->
    <!--<mat-icon style="color: orangered">fiber_manual_record</mat-icon>-->
    <!--<span>dark-warm-red-theme</span>-->
  <!--</button>-->
  <!--<button mat-menu-item (click)="application.brandingTheme='dark-grey-red-theme'">-->
    <!--<mat-icon style="color: #bdbdbd">fiber_manual_record</mat-icon>-->
    <!--<span>dark-grey-red-theme</span>-->
  <!--</button>-->
  <!--<button mat-menu-item (click)="application.handleLogout()">-->
    <!--<mat-icon>power_settings_new</mat-icon>-->
    <!--<span>Sign out</span>-->
  <!--</button>-->
</div>
